<p>{{ lstDataset.length }} datasets in the system</p>

<mat-accordion displayMode="flat" multi togglePosition="before">
@for (dataset of lstDataset; track $index) {
<mat-expansion-panel>
    <mat-expansion-panel-header>
        <div>Dataset name : {{ dataset.name }}, label : {{ dataset.label }}</div>
    </mat-expansion-panel-header>
    {{ dataset.variables.length }} variables
    <table mat-table [dataSource]="dataset.variables">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef> Key </th>
            <td mat-cell *matCellDef="let element"> {{element.key}} </td>
        </ng-container>
        <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef> Label </th>
            <td mat-cell *matCellDef="let element"> {{element.label}} </td>
        </ng-container>
        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
        <ng-container matColumnDef="length">
            <th mat-header-cell *matHeaderCellDef> Length </th>
            <td mat-cell *matCellDef="let element"> {{element.length}} </td>
        </ng-container>
        <ng-container matColumnDef="format">
            <th mat-header-cell *matHeaderCellDef> Format </th>
            <td mat-cell *matCellDef="let element"> {{element.format}} </td>
        </ng-container>
        <ng-container matColumnDef="settings">
            <th mat-header-cell *matHeaderCellDef> Settings </th>
            <td mat-cell *matCellDef="let element"> {{element.settings}} </td>
        </ng-container>
        <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef> Comments </th>
            <td mat-cell *matCellDef="let element"> {{element.comments}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-expansion-panel>
}